import accountReducer from './account/reducers';
import applicationsReducer from './applications/reducers';
import candidateReducer from './candidates/reducers';
import certificationCategories from './certification_categories';
import conversationsReducer from './conversations/reducers';
import currentUserProfileReducer from './current_user_profile/reducers';
import educationFields from './education_fields';
import educationLevels from './education_levels';
import educationalQualifications from './educational_qualifications';
import employerReducer from './employer/reducers';
import flipper from './flipper';
import geographiesReducer from './geographies/reducers';
import jobSearchReducer from './job_search/reducers';
import messagesReducer from './messages/reducers';
import plansReducer from './plans/reducers';
import savedFilterSelectionReducer from './saved_filter_selections/reducers';
import userProfileMeta from './user_profile_metadata';
import notesReducer from './notes/reducers';
import hiringHeroConfigs from './hiring_hero_configs';

export const reducers = {
  account: accountReducer,
  applications: applicationsReducer,
  candidates: candidateReducer,
  certificationCategories: certificationCategories.reducer,
  conversations: conversationsReducer,
  currentUserProfile: currentUserProfileReducer,
  educationFields: educationFields.reducer,
  educationLevels: educationLevels.reducer,
  educationalQualifications: educationalQualifications.reducer,
  flipper: flipper.reducer,
  employer: employerReducer,
  geographies: geographiesReducer,
  jobSearches: jobSearchReducer,
  messages: messagesReducer,
  plans: plansReducer,
  savedFilterSelections: savedFilterSelectionReducer,
  userProfileMetadata: userProfileMeta.reducer,
  notes: notesReducer,
  hiringHeroConfigs: hiringHeroConfigs.reducer,
};
